export default Object.freeze({
  EvaluationDocument: 1,
  CopyOfThePEI: 22,
  SignedContract: 25,
  CompuMinute: 27,
  RemedyApprovalLetter: 28,
  Others: 37,
  ReassessmentEvidencingTheChangeInFrequencyAndItsMinutesOfTheCOMPUMeeting: 32,
  PEIWithTheCorrespondingAmendments: 33,
  ReportAchievementAndJustification: 34,
  MinuteAndPEIThatEvidenceTheAEERecommendations: 35,
  AuthorizationLetterFromTheParentsToReceiveTheServiceByAnotherSpecialist: 36,
  InterventionPlan: 39,
  ProgressReport: 40,
  AttendanceSheet: 41,
  LicenseDocuments: 106,
  Evaluation: 75,
  SpecialistLicense: 5,
  PrBackgroundCheckProgramCertification: 93,
  SinglePermit: 97,
  PrBackgroundCheck300: 103,
  AuthorizationLetterFromTheParentsAndOrTutor: 109,
});
